
































































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import LearningRequestFormCreateV2 from "@/components/learning-request-v2/LearningRequestFormCreateV2.vue";
import { learningRequestApi } from "@/getinfo-api";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { StatusProfile as IStatusProfile } from "@/api-v2/learning-requests/models";
import { Action as IAction } from "@/api-v2/learning-requests/models";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import ProfileStatusForm from "@/components/learning-request-v2/ProfileStatusForm.vue";
import ProfileStatusItem from "@/components/learning-request-v2/ProfileStatusItem.vue";
import draggable from "vuedraggable";

@Component({
  components: {
    ProfileStatusItem,
    ProfileStatusForm,
    TextField,
    CBlock,
    CustomButton,
    CField,
    CPageButtons,
    LearningRequestFormCreateV2,
    CPage,
    draggable
  }
})
export default class Profile extends Vue {
  profile!: IStatusProfile;
  actions!: Array<IAction>;
  isAddNewStatus: boolean = false;
  isSortedInProcess: boolean = false;
  isLoading: boolean = false;

  data() {
    return {
      profile: undefined,
      actions: undefined
    };
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get statusesOrder() {
    return this.profile?.statuses?.map(el => el.id);
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "profiles" },
        label: `${this.$tc(this.$translate.LearningRequestProfile)}`
      },
      {
        label: this.profile.title
      }
    ];
  }

  async sortStatusesOrder() {
    if (this.profile?.id) {
      try {
        this.isSortedInProcess = true;
        await learningRequestApi.StatusProfiles.sortStatuses(
          this.profile.id,
          this.statusesOrder
        );
        this.$bvToast.toast(
          `${this.$tc(this.$translate.SortingHasBeenChanged)}`,
          {
            variant: "success",
            title: `${this.$tc(this.$translate.Success)}`
          }
        );
      } catch (err) {
        await this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      } finally {
        this.isSortedInProcess = false;
      }
    }
  }

  async getProfile() {
    await learningRequestApi.StatusProfiles.getProfile(
      this.$route.params.id
    ).then(res => {
      this.profile = res.data;
    });
  }

  async getActions() {
    learningRequestApi.Action.listActions().then(res => {
      this.actions = res.data;
    });
  }

  async addStatus(form: any) {
    await learningRequestApi.StatusProfiles.createStatus(this.profile.id, form);
    await this.getProfile();
    this.isAddNewStatus = false;
  }

  init() {
    this.getProfile();
    this.getActions();
  }

  created() {
    this.init();
  }
}
